__turbopack_context__.v({
  "close": "footnote-module-scss-module__SCYGca__close",
  "footnote": "footnote-module-scss-module__SCYGca__footnote",
  "modal": "footnote-module-scss-module__SCYGca__modal",
  "wrapper": "footnote-module-scss-module__SCYGca__wrapper",
});
